import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { UserService } from '../../services/user.service';
import { ReportService } from "../../services/report.service";
import { NotificationsService } from 'angular2-notifications';

const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}

@Component({
    selector: 'app-edit-collateral-deposit',
    templateUrl: './edit-collateral-deposit.component.html',
    styleUrls: ['./edit-collateral-deposit.component.css']
})
export class EditCollateralDepositDialog {
    collateralDepositForm: FormGroup;
    users: any[] = [];
    userid: string = '';
    dropdownSettings = {};
    selectedItems: any = [];
    selectedItemIds: string[] = [];
    constructor(
        public dialogRef: MatDialogRef<EditCollateralDepositDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public fb: FormBuilder,
        public userService: UserService,
        private reportService: ReportService,
        public notifSer : NotificationsService
    ) { }

    async ngOnInit() {
        this.collateralDepositForm = this.fb.group({
            userid: ['', Validators.required],
            note: ['', Validators.required],
        });
        await this.getUserForDropdown();

        this.dropdownSettings = {
            singleSelection: true,
            text: 'Select User',
            itemsShowLimit: 1,
            enableSearchFilter: true,
            classes: 'myclass custom-class'
        };

        this.selectedItems = [
            {"id":this.data.userid,"itemName":this.data.user_name}
        ]
        console.log(this.data)
    }
    onItemSelect(item: any) {
        this.collateralDepositForm.get('userid').setValue(item.id);
    }
    OnItemDeSelect() {
        this.collateralDepositForm.get('userid').setValue('');
    }
    getUserForDropdown() {
        this.userService.getUserForDropdown().subscribe(users => {
            this.users = users.map(item => {
                return {
                    id: item._id,
                    itemName: item.name
                }
            });;
        })
    }
    editCollateralDeposit() {
        const { notif } = defaults;
        try {
            if (this.collateralDepositForm.valid) {
                this.userService.csrf().subscribe(success => {
                    this.collateralDepositForm.value['_csrf'] = success['_csrf'];
                    this.collateralDepositForm.value['_id'] = this.data._id;
                    this.reportService.editCollateralDeposit(this.collateralDepositForm.value).subscribe(response => {
                        if (response.status) {
                            this.notifSer.success('Success', response.message, notif)
                            // Emit the form data when closing the dialog
        
                            this.dialogRef.close({ success: true, data: response.message });
        
                        } else this.notifSer.error('Error', response.message, notif);
                    }, err => this.notifSer.error('Error', err.error.message, notif))
                })
            }else{
                this.notifSer.error('Error', 'Please select user', notif)
            }
        } catch (error) {

        }
    }
}


// WEBPACK FOOTER //
// ./src/app/collateral-deposit/edit-collateral-deposit/edit-collateral-deposit.component.ts